import { SupportedLanguages } from '../GeneralTypes';

export type DeliveryCountry = {
  countryCode: string;
  countryId: number;
  countryIso: string;
  countryTranslations: Partial<Record<SupportedLanguages, CountryTranslation>>;
};

export type CountryTranslation = {
  countryDescription: string;
  languageCode: string;
  languageId: number;
};

export type DeliveryCountriesResponse = {
  countryResourceList: Array<DeliveryCountry>;
};

export const deliveryCountries: Array<DeliveryCountry> = [
  {
    countryCode: 'AT',
    countryId: 1,
    countryIso: '040',
    countryTranslations: {
      EN: {
        countryDescription: 'Austria',
        languageCode: 'EN',
        languageId: 3,
      },
    },
  },
];
